export function getFileName(url) {
  const num = url.lastIndexOf('/') + 1;
  let fileName = url.substring(num);
  // 把参数和文件名分割开
  fileName = decodeURI(fileName.split('?')[0]);
  return fileName;
}

function saveAs(data, name) {
  const urlObject = window.URL || window.webkitURL || window;
  const export_blob = new window.Blob([data]);
  const save_link = document.createElementNS('http://www.w3.org/1999/xhtml', 'a');
  save_link.href = urlObject.createObjectURL(export_blob);
  save_link.download = name;
  save_link.click();
}
/**
 * 获取页面文件名
 * @param url 文件url
 */
function downloadUrlFile(url) {
  url = url.replace(/\\/g, '/');
  const xhr = new window.XMLHttpRequest();
  xhr.open('GET', url, true);
  xhr.responseType = 'blob';
  // xhr.setRequestHeader('Authorization', 'Basic a2VybWl0Omtlcm1pdA==');
  xhr.onload = () => {
    if (xhr.status === 200) {
      // 获取文件blob数据并保存
      const fileName = getFileName(url);
      saveAs(xhr.response, fileName);
    }
  };

  xhr.send();
}

export default downloadUrlFile;
